module.exports = __webpack_public_path__ + "img/activity_tip.d34e8803.png";